/**
 * Product Upgrades V2 JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {
  const getPromoCents = (fullCents) => {
    const promo = window.theme?.promoPricing;
    const percent = Number(promo?.percent || 0);
    const amount = Number(fullCents || 0);
    if (promo?.enabled && promo?.autoApply && percent > 0 && amount > 0) {
      return Math.floor((amount * (100 - percent)) / 100);
    }
    return amount;
  };

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) {
      const format = window.theme?.moneyFormat || window.Shopify?.money_format || '{{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }
    return `$${(Number(cents || 0) / 100).toFixed(0)}`;
  };

  const updateCardContent = (select) => {
    const selectedOption = select.options[select.selectedIndex];
    const card = select.closest('.product-upgrades-v2__item');
    if (!card || !selectedOption) return;

    const variantId = select.value;
    const fullPrice = Number(selectedOption.dataset.price || 0);
    const shopifyCompare = Number(selectedOption.dataset.comparePrice || 0);
    const promo = window.theme?.promoPricing;
    const promoEnabled = Boolean(promo?.enabled && promo?.autoApply);
    const salePrice = getPromoCents(fullPrice);
    const comparePrice = promoEnabled
      ? fullPrice
      : shopifyCompare > fullPrice
        ? shopifyCompare
        : 0;

    const pTitle = selectedOption.dataset.productTitle;
    const pDesc = selectedOption.dataset.productDesc;
    const pImg = selectedOption.dataset.productImage;

    const hiddenInput = card.querySelector('.product-upgrades-v2__item-id');
    if (hiddenInput) {
      hiddenInput.value = variantId;
      hiddenInput.dataset.upgradePrice = String(salePrice);
      hiddenInput.dataset.upgradeComparePrice = String(comparePrice > 0 ? comparePrice : fullPrice);
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (pImg) {
      const imgEl = card.querySelector('.product-upgrades-v2__image');
      const placeholder = card.querySelector('.product-upgrades-v2__image-placeholder');
      if (imgEl) {
        imgEl.removeAttribute('srcset');
        imgEl.src = pImg;
        imgEl.style.display = 'block';
        if (placeholder) placeholder.style.display = 'none';
      }
    }

    if (pTitle) {
      const titleEl = card.querySelector('.product-upgrades-v2__name');
      if (titleEl) titleEl.textContent = pTitle;
    }

    if (pDesc) {
      const descEl = card.querySelector('.product-upgrades-v2__desc');
      if (descEl) descEl.textContent = pDesc;
    }

    const priceCurrentEl = card.querySelector('.product-upgrades-v2__price-current');
    const priceCompareEl = card.querySelector('.product-upgrades-v2__price-compare');

    if (priceCurrentEl) {
      priceCurrentEl.textContent = `+${formatMoney(salePrice)}`;
    }

    if (priceCompareEl) {
      if (comparePrice > salePrice) {
        priceCompareEl.textContent = `+${formatMoney(comparePrice)}`;
        priceCompareEl.style.display = '';
      } else {
        priceCompareEl.style.display = 'none';
      }
    }
  };

  const initUpgradesV2 = () => {
    const containers = document.querySelectorAll('.product-upgrades-v2');

    containers.forEach((container) => {
      const variantSelectors = container.querySelectorAll('.product-upgrades-v2__variant-select');

      variantSelectors.forEach((select) => {
        if (select.classList.contains('multi-product-select')) {
          updateCardContent(select);
        }
        select.addEventListener('change', () => updateCardContent(select));
      });
    });
  };

  initUpgradesV2();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initUpgradesV2);
  }
});
